/*
*
* File JS componente accordion
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './half-txt-bg-map.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const halfTextBgMap = () => {
    
    const searchingMap = document.querySelector('#searching-map');
    const inputSearching = document.querySelector('#input-searching');
    if(!searchingMap || !inputSearching) return;

    searchingMap.addEventListener('click', (e) => {
        e.preventDefault();
        const pageLink = e.target.getAttribute('data-href');
        const value = inputSearching.value;
        const link = `${pageLink}?${value}`;

        if(value != '' ){
            window.location.href = link;
        }else{
            window.location.href = pageLink;
        }

    });
 
}



export default halfTextBgMap;

//--------------------------------------------------------------------//